import React from 'react';
import { URI } from '../env';
import '../../public/scss/header.scss';

const Header = () => {
    return (
        <header className="header">
            <div className="header__top">
                <div className="container">
                    <div className="header__top-inner">
                        <a href="https://www.allstate.com/allstate-benefits/main.aspx" rel="noopener noreferrer" target="_blank" className="header__top-link">
                            AllstateBenefits.com
                        </a>
                        <a href="https://www.allstate.com/" rel="noopener noreferrer" target="_blank" className="header__top-link">
                            Allstate.com
                        </a>
                    </div>
                </div>
            </div>

            <div className="header__bottom">
                <div className="nav-bar-container">
                    <a href={URI} aria-label="allstate_provider" className="header__logo-link">
                        <span className="header__logo"> </span>
                    </a>
                    <div className="header__bottom-inner">
                        <span className="header__txt">Allstate Benefits</span>
                        <span className="header__txt__title">Provider Search</span>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
